import { type Message } from '@/features/messaging/Message'
import { computed } from 'mobx'
import { markdownToHtml } from '@/utils/markdown-util'
import { type MessageContentViewModel } from '@/features/messaging/MessageViewModel'

/**
 * Text content.
 */
export class TextMessageContentViewModel implements MessageContentViewModel {
  constructor(readonly message: Message) {}

  /**
   * The rendered HTML content from Markdown.
   */
  @computed
  get htmlContent() {
    switch (this.message.content.type) {
      case 'Call':
      case 'Progression':
        return ''
    }

    return markdownToHtml(this.message.content.text)
  }
}
